export default [
  {
    id: 362411314,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNjI0MTEzMTQ=',
    name: 'app-ideas',
    full_name: 'dangvannhang/app-ideas',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/app-ideas',
    description:
      'A Collection of application ideas which can be used to improve your coding skills.',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/app-ideas',
    forks_url: 'https://api.github.com/repos/dangvannhang/app-ideas/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/app-ideas/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/app-ideas/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/issues/events{/number}',
    events_url: 'https://api.github.com/repos/dangvannhang/app-ideas/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/app-ideas/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/dangvannhang/app-ideas/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/app-ideas/deployments',
    created_at: '2021-04-28T09:28:41Z',
    updated_at: '2021-04-28T09:28:43Z',
    pushed_at: '2021-04-25T11:00:06Z',
    git_url: 'git://github.com/dangvannhang/app-ideas.git',
    ssh_url: 'git@github.com:dangvannhang/app-ideas.git',
    clone_url: 'https://github.com/dangvannhang/app-ideas.git',
    svn_url: 'https://github.com/dangvannhang/app-ideas',
    homepage: '',
    size: 640,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 351341338,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNTEzNDEzMzg=',
    name: 'backend-piccine',
    full_name: 'dangvannhang/backend-piccine',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/backend-piccine',
    description:
      'Đây là toàn bộ source code backend cho dự án IT-Business-Project của PicCine Team.',
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/backend-piccine',
    forks_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/backend-piccine/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/backend-piccine/deployments',
    created_at: '2021-03-25T07:10:09Z',
    updated_at: '2021-06-09T13:36:38Z',
    pushed_at: '2021-06-10T06:18:07Z',
    git_url: 'git://github.com/dangvannhang/backend-piccine.git',
    ssh_url: 'git@github.com:dangvannhang/backend-piccine.git',
    clone_url: 'https://github.com/dangvannhang/backend-piccine.git',
    svn_url: 'https://github.com/dangvannhang/backend-piccine',
    homepage: '',
    size: 4232,
    stargazers_count: 2,
    watchers_count: 0,
    language: 'PHP',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 367362519,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNjczNjI1MTk=',
    name: 'backend-vote-web',
    full_name: 'dangvannhang/backend-vote-web',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/backend-vote-web',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/backend-vote-web',
    forks_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/backend-vote-web/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/backend-vote-web/deployments',
    created_at: '2021-05-14T12:55:24Z',
    updated_at: '2021-06-27T16:59:45Z',
    pushed_at: '2021-06-27T16:59:43Z',
    git_url: 'git://github.com/dangvannhang/backend-vote-web.git',
    ssh_url: 'git@github.com:dangvannhang/backend-vote-web.git',
    clone_url: 'https://github.com/dangvannhang/backend-vote-web.git',
    svn_url: 'https://github.com/dangvannhang/backend-vote-web',
    homepage: null,
    size: 307,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'PHP',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 389714295,
    node_id: 'MDEwOlJlcG9zaXRvcnkzODk3MTQyOTU=',
    name: 'complete-javascript-course',
    full_name: 'dangvannhang/complete-javascript-course',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/complete-javascript-course',
    description:
      'Starter files, final projects, and FAQ for my Complete JavaScript course',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/complete-javascript-course',
    forks_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/complete-javascript-course/deployments',
    created_at: '2021-07-26T17:22:44Z',
    updated_at: '2021-07-26T17:22:45Z',
    pushed_at: '2021-07-25T20:15:59Z',
    git_url: 'git://github.com/dangvannhang/complete-javascript-course.git',
    ssh_url: 'git@github.com:dangvannhang/complete-javascript-course.git',
    clone_url: 'https://github.com/dangvannhang/complete-javascript-course.git',
    svn_url: 'https://github.com/dangvannhang/complete-javascript-course',
    homepage:
      'https://www.udemy.com/the-complete-javascript-course/?couponCode=C3GITHUB10',
    size: 45678,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 340066130,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNDAwNjYxMzA=',
    name: 'DeepFaceLab',
    full_name: 'dangvannhang/DeepFaceLab',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/DeepFaceLab',
    description: 'DeepFaceLab is the leading software for creating deepfakes.',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab',
    forks_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/issues/events{/number}',
    events_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/dangvannhang/DeepFaceLab/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/DeepFaceLab/deployments',
    created_at: '2021-02-18T13:55:47Z',
    updated_at: '2021-02-18T13:55:48Z',
    pushed_at: '2021-01-27T13:59:05Z',
    git_url: 'git://github.com/dangvannhang/DeepFaceLab.git',
    ssh_url: 'git@github.com:dangvannhang/DeepFaceLab.git',
    clone_url: 'https://github.com/dangvannhang/DeepFaceLab.git',
    svn_url: 'https://github.com/dangvannhang/DeepFaceLab',
    homepage: '',
    size: 834904,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'gpl-3.0',
      name: 'GNU General Public License v3.0',
      spdx_id: 'GPL-3.0',
      url: 'https://api.github.com/licenses/gpl-3.0',
      node_id: 'MDc6TGljZW5zZTk=',
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 370895481,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzA4OTU0ODE=',
    name: 'EssentialTypeScript',
    full_name: 'dangvannhang/EssentialTypeScript',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/EssentialTypeScript',
    description:
      'Courseware and demos for Lynda.com Essential TypeScript course',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/EssentialTypeScript',
    forks_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/EssentialTypeScript/deployments',
    created_at: '2021-05-26T03:31:53Z',
    updated_at: '2021-05-26T03:31:54Z',
    pushed_at: '2016-03-31T05:40:05Z',
    git_url: 'git://github.com/dangvannhang/EssentialTypeScript.git',
    ssh_url: 'git@github.com:dangvannhang/EssentialTypeScript.git',
    clone_url: 'https://github.com/dangvannhang/EssentialTypeScript.git',
    svn_url: 'https://github.com/dangvannhang/EssentialTypeScript',
    homepage: null,
    size: 45,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 360357202,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNjAzNTcyMDI=',
    name: 'javascript-essential-training-2832077',
    full_name: 'dangvannhang/javascript-essential-training-2832077',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url:
      'https://github.com/dangvannhang/javascript-essential-training-2832077',
    description: 'JavaScript Essential Training',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077',
    forks_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/javascript-essential-training-2832077/deployments',
    created_at: '2021-04-22T01:33:27Z',
    updated_at: '2021-04-22T01:33:28Z',
    pushed_at: '2021-04-12T20:33:29Z',
    git_url:
      'git://github.com/dangvannhang/javascript-essential-training-2832077.git',
    ssh_url:
      'git@github.com:dangvannhang/javascript-essential-training-2832077.git',
    clone_url:
      'https://github.com/dangvannhang/javascript-essential-training-2832077.git',
    svn_url:
      'https://github.com/dangvannhang/javascript-essential-training-2832077',
    homepage: null,
    size: 125,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'other',
      name: 'Other',
      spdx_id: 'NOASSERTION',
      url: null,
      node_id: 'MDc6TGljZW5zZTA=',
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 366001497,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNjYwMDE0OTc=',
    name: 'json-server',
    full_name: 'dangvannhang/json-server',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/json-server',
    description:
      'Get a full fake REST API with zero coding in less than 30 seconds (seriously)',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/json-server',
    forks_url: 'https://api.github.com/repos/dangvannhang/json-server/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/json-server/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/json-server/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/json-server/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/json-server/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/json-server/issues/events{/number}',
    events_url: 'https://api.github.com/repos/dangvannhang/json-server/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/json-server/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/json-server/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/json-server/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/json-server/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/json-server/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/json-server/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/json-server/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/json-server/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/json-server/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/json-server/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/json-server/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/json-server/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/json-server/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/json-server/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/json-server/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/json-server/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/json-server/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/json-server/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/json-server/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/dangvannhang/json-server/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/json-server/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/json-server/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/json-server/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/json-server/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/json-server/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/json-server/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/json-server/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/json-server/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/json-server/deployments',
    created_at: '2021-05-10T10:18:52Z',
    updated_at: '2021-05-10T10:18:53Z',
    pushed_at: '2021-04-30T12:27:44Z',
    git_url: 'git://github.com/dangvannhang/json-server.git',
    ssh_url: 'git@github.com:dangvannhang/json-server.git',
    clone_url: 'https://github.com/dangvannhang/json-server.git',
    svn_url: 'https://github.com/dangvannhang/json-server',
    homepage: '',
    size: 2663,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 320462653,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMjA0NjI2NTM=',
    name: 'laravel_book_room_hotel',
    full_name: 'dangvannhang/laravel_book_room_hotel',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/laravel_book_room_hotel',
    description: 'Here is project of NewbiesTeam with Nhang-Sim-Nguyet',
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel',
    forks_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/laravel_book_room_hotel/deployments',
    created_at: '2020-12-11T04:02:21Z',
    updated_at: '2021-04-12T05:52:52Z',
    pushed_at: '2020-12-11T04:07:58Z',
    git_url: 'git://github.com/dangvannhang/laravel_book_room_hotel.git',
    ssh_url: 'git@github.com:dangvannhang/laravel_book_room_hotel.git',
    clone_url: 'https://github.com/dangvannhang/laravel_book_room_hotel.git',
    svn_url: 'https://github.com/dangvannhang/laravel_book_room_hotel',
    homepage: null,
    size: 4363,
    stargazers_count: 1,
    watchers_count: 0,
    language: 'PHP',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 370205204,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzAyMDUyMDQ=',
    name: 'LearningTypeScript',
    full_name: 'dangvannhang/LearningTypeScript',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/LearningTypeScript',
    description:
      'Companion repository to the LinkedIn Learning Course "Learning TypeScript"',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/LearningTypeScript',
    forks_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/LearningTypeScript/deployments',
    created_at: '2021-05-24T02:28:55Z',
    updated_at: '2021-05-24T02:28:56Z',
    pushed_at: '2019-06-19T05:16:11Z',
    git_url: 'git://github.com/dangvannhang/LearningTypeScript.git',
    ssh_url: 'git@github.com:dangvannhang/LearningTypeScript.git',
    clone_url: 'https://github.com/dangvannhang/LearningTypeScript.git',
    svn_url: 'https://github.com/dangvannhang/LearningTypeScript',
    homepage: null,
    size: 140,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 391342947,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTEzNDI5NDc=',
    name: 'modern-responsive-demo-web',
    full_name: 'dangvannhang/modern-responsive-demo-web',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/modern-responsive-demo-web',
    description: 'I am creating a modern responsive demo website.',
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web',
    forks_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/modern-responsive-demo-web/deployments',
    created_at: '2021-07-31T11:56:26Z',
    updated_at: '2021-07-31T20:38:18Z',
    pushed_at: '2021-07-31T20:33:42Z',
    git_url: 'git://github.com/dangvannhang/modern-responsive-demo-web.git',
    ssh_url: 'git@github.com:dangvannhang/modern-responsive-demo-web.git',
    clone_url: 'https://github.com/dangvannhang/modern-responsive-demo-web.git',
    svn_url: 'https://github.com/dangvannhang/modern-responsive-demo-web',
    homepage: 'https://responsive-modern-web-dangvannhang.netlify.app/',
    size: 13953,
    stargazers_count: 2,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 330018888,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMzAwMTg4ODg=',
    name: 'notes',
    full_name: 'dangvannhang/notes',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/notes',
    description:
      'Here is place that I will show the way how to install packages, libraries, framework.',
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/notes',
    forks_url: 'https://api.github.com/repos/dangvannhang/notes/forks',
    keys_url: 'https://api.github.com/repos/dangvannhang/notes/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/notes/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/notes/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/notes/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/notes/issues/events{/number}',
    events_url: 'https://api.github.com/repos/dangvannhang/notes/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/notes/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/notes/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/notes/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/notes/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/notes/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/notes/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/notes/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/notes/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/dangvannhang/notes/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/notes/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/notes/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/notes/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/notes/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/notes/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/notes/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/notes/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/notes/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/notes/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/notes/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/dangvannhang/notes/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/notes/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/dangvannhang/notes/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/notes/issues{/number}',
    pulls_url: 'https://api.github.com/repos/dangvannhang/notes/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/notes/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/notes/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/dangvannhang/notes/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/notes/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/notes/deployments',
    created_at: '2021-01-15T20:47:25Z',
    updated_at: '2021-06-20T09:00:46Z',
    pushed_at: '2021-06-20T09:00:44Z',
    git_url: 'git://github.com/dangvannhang/notes.git',
    ssh_url: 'git@github.com:dangvannhang/notes.git',
    clone_url: 'https://github.com/dangvannhang/notes.git',
    svn_url: 'https://github.com/dangvannhang/notes',
    homepage: '',
    size: 191,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 333238848,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMzMyMzg4NDg=',
    name: 'project_DiorSmart',
    full_name: 'dangvannhang/project_DiorSmart',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/project_DiorSmart',
    description:
      'There is project about e-commerce of my team. This is using restful api from laravel and frond-end is vuejs.',
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/project_DiorSmart',
    forks_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/project_DiorSmart/deployments',
    created_at: '2021-01-26T22:51:17Z',
    updated_at: '2021-03-17T01:54:11Z',
    pushed_at: '2021-03-11T03:03:56Z',
    git_url: 'git://github.com/dangvannhang/project_DiorSmart.git',
    ssh_url: 'git@github.com:dangvannhang/project_DiorSmart.git',
    clone_url: 'https://github.com/dangvannhang/project_DiorSmart.git',
    svn_url: 'https://github.com/dangvannhang/project_DiorSmart',
    homepage: '',
    size: 2811,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'PHP',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 376366123,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzYzNjYxMjM=',
    name: 'random-person_reactjs',
    full_name: 'dangvannhang/random-person_reactjs',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/random-person_reactjs',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/random-person_reactjs',
    forks_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/random-person_reactjs/deployments',
    created_at: '2021-06-12T19:08:43Z',
    updated_at: '2021-06-12T19:10:53Z',
    pushed_at: '2021-06-12T19:10:51Z',
    git_url: 'git://github.com/dangvannhang/random-person_reactjs.git',
    ssh_url: 'git@github.com:dangvannhang/random-person_reactjs.git',
    clone_url: 'https://github.com/dangvannhang/random-person_reactjs.git',
    svn_url: 'https://github.com/dangvannhang/random-person_reactjs',
    homepage: null,
    size: 188,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 373417845,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzM0MTc4NDU=',
    name: 'react-advanced-2020',
    full_name: 'dangvannhang/react-advanced-2020',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/react-advanced-2020',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/react-advanced-2020',
    forks_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/react-advanced-2020/deployments',
    created_at: '2021-06-03T07:23:44Z',
    updated_at: '2021-06-03T07:23:45Z',
    pushed_at: '2021-05-27T20:58:13Z',
    git_url: 'git://github.com/dangvannhang/react-advanced-2020.git',
    ssh_url: 'git@github.com:dangvannhang/react-advanced-2020.git',
    clone_url: 'https://github.com/dangvannhang/react-advanced-2020.git',
    svn_url: 'https://github.com/dangvannhang/react-advanced-2020',
    homepage: null,
    size: 293,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 373348890,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzMzNDg4OTA=',
    name: 'react-projects',
    full_name: 'dangvannhang/react-projects',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/react-projects',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/react-projects',
    forks_url: 'https://api.github.com/repos/dangvannhang/react-projects/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/react-projects/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/react-projects/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/react-projects/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/react-projects/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/react-projects/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/react-projects/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/react-projects/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/react-projects/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/react-projects/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/react-projects/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/react-projects/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/react-projects/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/react-projects/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/react-projects/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/react-projects/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/react-projects/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/react-projects/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/react-projects/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/react-projects/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/react-projects/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/react-projects/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/react-projects/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/react-projects/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/react-projects/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/react-projects/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/react-projects/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/react-projects/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/react-projects/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/react-projects/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/react-projects/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/react-projects/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/react-projects/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/react-projects/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/react-projects/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/react-projects/deployments',
    created_at: '2021-06-03T01:36:37Z',
    updated_at: '2021-06-03T01:36:38Z',
    pushed_at: '2021-05-19T18:28:01Z',
    git_url: 'git://github.com/dangvannhang/react-projects.git',
    ssh_url: 'git@github.com:dangvannhang/react-projects.git',
    clone_url: 'https://github.com/dangvannhang/react-projects.git',
    svn_url: 'https://github.com/dangvannhang/react-projects',
    homepage: null,
    size: 2748,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 392867014,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTI4NjcwMTQ=',
    name: 'search-github-users',
    full_name: 'dangvannhang/search-github-users',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/search-github-users',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/search-github-users',
    forks_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/search-github-users/deployments',
    created_at: '2021-08-05T01:22:32Z',
    updated_at: '2021-08-05T01:24:50Z',
    pushed_at: '2021-08-05T01:24:47Z',
    git_url: 'git://github.com/dangvannhang/search-github-users.git',
    ssh_url: 'git@github.com:dangvannhang/search-github-users.git',
    clone_url: 'https://github.com/dangvannhang/search-github-users.git',
    svn_url: 'https://github.com/dangvannhang/search-github-users',
    homepage: null,
    size: 0,
    stargazers_count: 1,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 376608957,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzY2MDg5NTc=',
    name: 'simple-pagination__reactjs',
    full_name: 'dangvannhang/simple-pagination__reactjs',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/simple-pagination__reactjs',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs',
    forks_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/simple-pagination__reactjs/deployments',
    created_at: '2021-06-13T18:02:39Z',
    updated_at: '2021-06-13T18:03:47Z',
    pushed_at: '2021-06-13T18:03:45Z',
    git_url: 'git://github.com/dangvannhang/simple-pagination__reactjs.git',
    ssh_url: 'git@github.com:dangvannhang/simple-pagination__reactjs.git',
    clone_url: 'https://github.com/dangvannhang/simple-pagination__reactjs.git',
    svn_url: 'https://github.com/dangvannhang/simple-pagination__reactjs',
    homepage: null,
    size: 188,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 392863366,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTI4NjMzNjY=',
    name: 'starter-project-react-github-search-users',
    full_name: 'dangvannhang/starter-project-react-github-search-users',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url:
      'https://github.com/dangvannhang/starter-project-react-github-search-users',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users',
    forks_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/starter-project-react-github-search-users/deployments',
    created_at: '2021-08-05T01:01:11Z',
    updated_at: '2021-08-05T01:01:12Z',
    pushed_at: '2021-01-06T07:00:37Z',
    git_url:
      'git://github.com/dangvannhang/starter-project-react-github-search-users.git',
    ssh_url:
      'git@github.com:dangvannhang/starter-project-react-github-search-users.git',
    clone_url:
      'https://github.com/dangvannhang/starter-project-react-github-search-users.git',
    svn_url:
      'https://github.com/dangvannhang/starter-project-react-github-search-users',
    homepage: null,
    size: 478,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 375770686,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzU3NzA2ODY=',
    name: 'todo-list_reactjs_localStorage',
    full_name: 'dangvannhang/todo-list_reactjs_localStorage',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/todo-list_reactjs_localStorage',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage',
    forks_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/teams',
    hooks_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/todo-list_reactjs_localStorage/deployments',
    created_at: '2021-06-10T16:58:55Z',
    updated_at: '2021-06-12T12:24:06Z',
    pushed_at: '2021-06-12T12:24:04Z',
    git_url: 'git://github.com/dangvannhang/todo-list_reactjs_localStorage.git',
    ssh_url: 'git@github.com:dangvannhang/todo-list_reactjs_localStorage.git',
    clone_url:
      'https://github.com/dangvannhang/todo-list_reactjs_localStorage.git',
    svn_url: 'https://github.com/dangvannhang/todo-list_reactjs_localStorage',
    homepage: null,
    size: 220,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 351757167,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNTE3NTcxNjc=',
    name: 'vuejs-base-app',
    full_name: 'dangvannhang/vuejs-base-app',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/vuejs-base-app',
    description: null,
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/vuejs-base-app',
    forks_url: 'https://api.github.com/repos/dangvannhang/vuejs-base-app/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/vuejs-base-app/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/vuejs-base-app/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/vuejs-base-app/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/vuejs-base-app/deployments',
    created_at: '2021-03-26T11:20:10Z',
    updated_at: '2021-03-26T11:20:11Z',
    pushed_at: '2021-01-22T12:48:42Z',
    git_url: 'git://github.com/dangvannhang/vuejs-base-app.git',
    ssh_url: 'git@github.com:dangvannhang/vuejs-base-app.git',
    clone_url: 'https://github.com/dangvannhang/vuejs-base-app.git',
    svn_url: 'https://github.com/dangvannhang/vuejs-base-app',
    homepage: null,
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 377744237,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzc3NDQyMzc=',
    name: 'wp-calypso',
    full_name: 'dangvannhang/wp-calypso',
    private: false,
    owner: {
      login: 'dangvannhang',
      id: 48082244,
      node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
      avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/dangvannhang',
      html_url: 'https://github.com/dangvannhang',
      followers_url: 'https://api.github.com/users/dangvannhang/followers',
      following_url:
        'https://api.github.com/users/dangvannhang/following{/other_user}',
      gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/dangvannhang/subscriptions',
      organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
      repos_url: 'https://api.github.com/users/dangvannhang/repos',
      events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/dangvannhang/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/dangvannhang/wp-calypso',
    description: 'The JavaScript and API powered WordPress.com',
    fork: true,
    url: 'https://api.github.com/repos/dangvannhang/wp-calypso',
    forks_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/forks',
    keys_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/teams',
    hooks_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/hooks',
    issue_events_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/issues/events{/number}',
    events_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/events',
    assignees_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/branches{/branch}',
    tags_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/tags',
    blobs_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/languages',
    stargazers_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/stargazers',
    contributors_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/contributors',
    subscribers_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/subscribers',
    subscription_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/subscription',
    commits_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/dangvannhang/wp-calypso/merges',
    archive_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/downloads',
    issues_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/labels{/name}',
    releases_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/dangvannhang/wp-calypso/deployments',
    created_at: '2021-06-17T07:33:46Z',
    updated_at: '2021-06-18T01:44:13Z',
    pushed_at: '2021-06-17T07:32:22Z',
    git_url: 'git://github.com/dangvannhang/wp-calypso.git',
    ssh_url: 'git@github.com:dangvannhang/wp-calypso.git',
    clone_url: 'https://github.com/dangvannhang/wp-calypso.git',
    svn_url: 'https://github.com/dangvannhang/wp-calypso',
    homepage: 'https://developer.wordpress.com/calypso/',
    size: 494710,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'gpl-2.0',
      name: 'GNU General Public License v2.0',
      spdx_id: 'GPL-2.0',
      url: 'https://api.github.com/licenses/gpl-2.0',
      node_id: 'MDc6TGljZW5zZTg=',
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'trunk',
  },
]
